import { getToken as getWebToken, onMessage } from 'firebase/messaging';
import { messaging } from '../config/firebase';
import { deleteFCMToken } from '../services/userService';

export const requestPermission = async (): Promise<boolean> => {
  const permission = await Notification.requestPermission();
  return permission === 'granted';
};

export const getToken = async (): Promise<string | null> => {
  try {
    const token = await getWebToken(messaging, {
      vapidKey: process.env.REACT_APP_VAPID_KEY,
    });
    console.log('FCM Token:', token);
    return token;
  } catch (err) {
    console.error('FCM getToken error (web):', err);
    return null;
  }
};

export const subscribeToMessages = (cb: (title: string, body: string) => void) => {
  return onMessage(messaging, (payload) => {
    const { title, body } = payload.notification ?? {};
    cb?.(title ?? '', body ?? '');
  });
};

export const deleteTokenFCM = async () => {
  try {
    const token = await getToken();
    if (token) {
      await deleteFCMToken(token);
    }
  } catch (error) {
    console.error('Error deleting FCM token:', error);
  }
};

